import auth from './auth0';
import logger from '../utils/logger';
const authProvider = {
    // called when the user attempts to log in
    login: () => {
        // logger.log('[AuthProvider] Login attempted - this should never be called');
        throw Object.assign(
            new Error("this should never be called"), 
            { code: 402 }
        );
    },

    // called when the user clicks on the logout button
    logout: () => {
        logger.log('[AuthProvider] Logout called');
        auth.logout();
        return Promise.resolve();
    },

    // called when the API returns an error
    checkError: ({ status }) => {
        // logger.log('[AuthProvider] Checking error status:', status);
        // Only logout on 401 (session expired/invalid token)
        // For 403 (forbidden/insufficient permissions), keep user logged in
        if (status === 401) {
            // logger.log('[AuthProvider] Unauthorized - logging out');
            auth.logout();
            return Promise.reject();
        }
        // For 403, don't logout - just let React Admin show the error
        return Promise.resolve();
    },

    // called when the user navigates to a new location
    checkAuth: (params) => {
        logger.log('[AuthProvider] Checking auth for location:', params?.location);

        if (params?.location === '/callback') {
            logger.log('[AuthProvider] On callback page, allowing through');
            return Promise.resolve(); // Currently trying to validate authenticity. Function will be called again after redirect after authentication succeeds or fails.
        }
        else if (auth.isAuthenticated()) {
            logger.log('[AuthProvider] User is authenticated');
            auth.renewSessionIfExpiringSoon();
            return Promise.resolve();
        }
        else {
            // When we reject the promise here, react-admin redirects the user to the login page, and we lose 
            // the info of where they were trying to go. By clearing auth state and reloading instead, the user
            // gets to log in and continue on to their location.
            // logger.log('[AuthProvider] Not authenticated, clearing auth and reloading');
            auth.logout();
            window.location.reload();
            return;
        }
    },

    // called to get the user's permissions
    getPermissions: () => {
        // logger.log('[AuthProvider] Getting permissions');
        const permissions = auth.getPermissions();
        return Promise.resolve(permissions);
    },

    // called to get the user's identity
    getIdentity: () => {
        // logger.log('[AuthProvider] Getting identity');
        const userProfile = auth.getUserProfile();
        return Promise.resolve({
            id: userProfile?.name || 'admin',
            fullName: userProfile?.nickname || 'Administrator',
            avatar: userProfile?.picture || null,
            email: userProfile?.name,
            displayName: userProfile?.nickname || 'Administrator',
            role: auth.getPacifyRole(),
            userRole: userProfile?.userRole,
            // Additional fields for React-Admin UI
            title: userProfile?.userRole || 'User',
            subtitle: userProfile?.name || '',
            avatarProps: { 
                sx: { width: 30, height: 30 },
                src: userProfile?.picture || null
            }
        });
    }
};

export default authProvider;

